import React, { useEffect } from "react";
import { Button, Col, Form, Row, Space, Input } from "antd";
import "./Jd-Answer-Create.css";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const iconCss: React.CSSProperties = { fontSize: "1.3rem", color: "#ff4d4f" };

export interface IProps {
  data?: any;
  onClose?: () => void;
  onFinish?: any;
  onClear?: any;
  disabledForm?: boolean;
  fromPage?: any;
  questionData?: any;
  rowData?: any;
}
const JdAnswerCreate: React.FC<IProps> = (pageProps) => {
  const [form] = Form.useForm();
  // const [questionList, setQuestionOptions] = useState([]);
  const onFinish = (values: any) => {
    pageProps.onFinish(values);
  };
  // const onClear = () => {
  //   //reset form
  //   form.resetFields();
  //   if (pageProps.onClear) pageProps.onClear();
  //   if (pageProps?.questionData?._id) {
  //     form.setFieldsValue({ question: pageProps?.questionData?._id });
  //   }
  // };
  // useEffect(() => {
  //   getQuestionList().then((res: any) => {
  //     setQuestionOptions(res);
  //   });
  // }, []);
  useEffect(() => {
    if (pageProps.data && Object.keys(pageProps.data)) {
      setFormValue(pageProps.data);
    } else if (pageProps?.questionData?._id) {
      form.setFieldsValue({ question_id: pageProps?.questionData?._id });
      form.setFieldsValue({ question: pageProps?.questionData?.sfdc_id });
      form.setFieldsValue({
        answers: [
          {
            name: "",
            answer: "",
            score: "",
            order: pageProps?.rowData?.length + 1 || 1,
          },
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageProps?.data, pageProps?.questionData?._id]);

  const setFormValue = (data: any) => {
    console.log(' data', data)
    form.setFieldsValue({ sfdc_id:data.sfdc_id });
    form.setFieldsValue({ name: data.name });
    form.setFieldsValue({ answer: data.answer });
    form.setFieldsValue({ score: data.score });
    form.setFieldsValue({
      order: data.order || pageProps?.rowData?.length + 1 || 1,
    });
    form.setFieldsValue({ question: data.question });
    form.setFieldsValue({
      answers: [
        {
          name: data.name,
          answer: data.answer,
          score: data.score,
          order: data.order || pageProps?.rowData?.length + 1 || 1
        },
      ],
    });
  };
  const pageWithFrom = () => {
    return (
      <>
        <Form
          layout="vertical"
          onFinish={onFinish}
          form={form}
          hideRequiredMark
          autoComplete="off"
        >
          {pageWithoutForm()}
          <Row>
            <Col span={24}>
              <Space>
                <Button onClick={pageProps.onClose}>Cancel</Button>
                {/* {pageProps?.data ? (
                ) : (
                  <Button onClick={onClear}>Clear</Button>
                )} */}
                <Button type="primary" htmlType="submit">
                  Submit{" "}
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </>
    );
  };
  const pageWithoutForm = () => {
    return (
      <>
        <div style={{ marginBottom: "20px" }}>
          <Row>
            {/* <Col span={12}>
              <strong>Question Name:</strong> {pageProps?.questionData?.name}
            </Col> */}

            <Col span={24}>
              <strong>Question:</strong> {pageProps?.questionData?.name || 'N/A'}
            </Col>
          </Row>
        </div>

        <Row gutter={16}>
          <Form.Item name="question_id" style={{ display: "none" }}>
            <Input value={pageProps?.questionData?._id} />
          </Form.Item>
          <Form.Item name="question" style={{ display: "none" }}>
            <Input value={pageProps?.questionData?.sfdc_id} />
          </Form.Item>
          <Form.List name="answers">
            {(fields, { add, remove }) => (
              <React.Fragment>
                {!pageProps?.data && (
                  <Col span={12}>
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => {
                          add();
                        }}
                        // style={{ width: '80%' }}
                        icon={<PlusOutlined />}
                      >
                        Add Answer
                      </Button>
                    </Form.Item>
                  </Col>
                )}
                <Col span={24}>
                  <div key="antDesign" className="addMoreGrid">
                    <div key="jdcAddMoreAnswer" className="addMore">
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: "flex", marginBottom: 8 }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            label="Answer name"
                            name={[name, "name"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "Answer name is required",
                              },
                            ]}
                          >
                            <Input placeholder="Answer name" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            label="Answer"
                            name={[name, "answer"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "Answer is required",
                              },
                            ]}
                          >
                            <Input placeholder="Answer" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            label="Score"
                            name={[name, "score"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ maxWidth: 150 }}
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "Score is required",
                              },
                              {
                                validator: (_, value) => {
                                  if (value && (isNaN(value) || value < 0)) {
                                    return Promise.reject(
                                      "Score must be greater than or equal to 0"
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input placeholder="Score" />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            label="Order"
                            name={[name, "order"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ maxWidth: 150 }}
                            rules={[
                              {
                                validator: (_, value) => {
                                  // Check that order is a number greater than 0
                                  if (value && (isNaN(value) || value <= 0)) {
                                    return Promise.reject(
                                      "Order must be greater than 0"
                                    );
                                  }

                                  if (String(value).includes(".")) {
                                    return Promise.reject(
                                      "Please enter a natural number."
                                    );
                                  }
                                  const allOrders = form
                                    .getFieldsValue()
                                    ?.answers?.filter(
                                      (each: any) => each?.order
                                    )
                                    ?.map((each: any) => each?.order);
                                  const orderCount = allOrders?.filter(
                                    (order: any) => +order === +value
                                  );

                                  if (orderCount?.length > 1) {
                                    return Promise.reject(
                                      "Order value must be unique"
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input placeholder="Order" maxLength={4} />
                          </Form.Item>
                            {key == 0 && (
                              <Form.Item
                                label="Remove"
                                className="answerRemoveLabel"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{ maxWidth: 40 }}
                              >
                                <MinusCircleOutlined
                                  style={iconCss}
                                  title="Remove"
                                  disabled
                                />
                              </Form.Item>
                            )}
                          {!pageProps?.data &&
                           key > 0 && (
                              <Form.Item
                                label="Remove"
                                className="answerRemoveLabel"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{ maxWidth: 40 }}
                              >
                                <MinusCircleOutlined
                                  style={iconCss}
                                  title="Remove"
                                  onClick={() => remove(name)}
                                />
                              </Form.Item>
                            )}
                        </Space>
                      ))}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            )}
          </Form.List>
        </Row>
      </>
    );
  };

  return (
    <div className="add-answer-content">
      {pageProps.fromPage === "addQuest" ? pageWithoutForm() : pageWithFrom()}
    </div>
  );
};

export default JdAnswerCreate;
